// This will handle whether HFX comes in as an ID or as full http or as old lumiastream type
export function hfxGetUrl(command, getPreview = false) {
	const item = !getPreview ? command.hfx : command.hfxPreview ?? command.hfx;
	const origin = command.hfxOrigin ?? 'lumiastream';

	if (item?.startsWith('https')) {
		return item;
	} else if (origin === 'lumiastream') {
		// Before HUDFX was made Lumia Stream didn't send origin so we can assume no origin means Lumia Stream
		if (getPreview) {
			return `https://storage.lumiastream.com/overlays/lumia/hfx/previews/${item}.webm.gif`;
		} else {
			return `https://storage.lumiastream.com/overlays/lumia/hfx/${item}.webm`;
		}
	} else {
		return `https://cdn.hudfx.io/hfx/${item}${getPreview ? '.gif' : '.webm'}`;
	}
}
